// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import brandDeterminationActions from '../../actions/brandDetermination';
import BrandDetermination from './BrandDetermination';
import confirmBrandActions from '../../actions/confirmBrand';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),

        enableContinueButton: get(state, 'brandDetermination.enableContinueButton', false),
        enableBackButton: get(state, 'brandDetermination.enableBackButton', true),
        serviceError: get(state, 'brandDetermination.serviceError', ''),

        currencyList: get(state, 'brandDetermination.currencyList', []),
        currency: get(state, 'brandDetermination.currency', ''),
        currencyError: get(state, 'brandDetermination.currencyError', ''),

        bankingCountryList: get(state, 'brandDetermination.bankingCountryList', []),
        bankingCountryCode: get(state, 'brandDetermination.bankingCountryCode', ''),
        bankingCountryCodeError: get(state, 'brandDetermination.bankingCountryCodeError', ''),

        primarySite: get(state, 'brandDetermination.primarySite', {}),
        primarySiteMap: get(state, 'brandDetermination.primarySiteMap', {}),
        siteName: get(state, 'system.siteName', ''),
        bankingCountryInfo: get(state, 'brandDetermination.bankingCountryInfo', {}),
        dyff: get(state,'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        confirmBrandActions: bindActionCreators(confirmBrandActions, dispatch),
        brandDeterminationActions: bindActionCreators(brandDeterminationActions, dispatch),
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class BrandDeterminationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleBankingCountryChange = this.handleBankingCountryChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    componentWillMount() {
        if (isEmpty(this.props.primarySiteMap)) {
            this.props.appActions.enableLoadOverLay(true);
            this.props.brandDeterminationActions.getSupportedSites();
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Brand Determination Page');
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Brand Determination Page submit'
        }, {});

        this.props.confirmBrandActions.confirmBrand(this.props.primarySite);
        this.props.appActions.changeAppState('CONFIRM_BRAND');
    }

    handleCurrencyChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.brandDeterminationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.brandDeterminationActions.toggleContinueButton();
    }

    handleBankingCountryChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Banking location selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.brandDeterminationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.brandDeterminationActions.toggleContinueButton();
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.brandDeterminationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    handleAlertDismiss() {
        this.props.brandDeterminationActions.dismissAlertBox();
    }


    setFieldsError(errorField) {
        const fields = [
            'bankingCountry',
            'currencySelection',
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.brandDeterminationActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'bankingCountry' && !this.props.bankingCountryCode)
                || (fieldVal === 'currencySelection' && !this.props.currency)
            ) {
                this.props.brandDeterminationActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleBackButtonClick(event) {
        const languageCurrencyMismatchFlag = this.props.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH;
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });

        if (this.props.userType === 'PPM') {
            if (!languageCurrencyMismatchFlag) {
                // NOTE: only route back to MULTIPLE_ACCOUNTS if dyff flag is off, otherwise stay on brand determination page
                this.props.appActions.changeAppState('MULTIPLE_ACCOUNTS');
            }
            return;
        }
        // For IPM Users clear session and redirect back to intro
        window.location = '/p/onboard'
    }

    render() {
        return (<div>
            <BrandDetermination
                translations={this.props.translations}

                bankingCountryList={this.props.bankingCountryList}
                bankingCountryCode={this.props.bankingCountryCode}
                handleBankingCountryChange={this.handleBankingCountryChange}
                bankingCountryCodeError={this.props.bankingCountryCodeError}
                handleBankingCountryOnBlur={this.showOnFieldBlur}

                currencyList={this.props.currencyList}
                currency={this.props.currency}
                handleCurrencyChange={this.handleCurrencyChange}
                currencyError={this.props.currencyError}
                handleCurrencyOnBlur={this.showOnFieldBlur}

                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                enableContinueButton={this.props.enableContinueButton}
                enableBackButton={this.props.enableBackButton}
                handleFormSubmit={this.handleFormSubmit}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleBackButtonClick={this.handleBackButtonClick}
            />
        </div>);
    }
}

BrandDeterminationContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,
    bankingCountryCode: PropTypes.string,
    bankingCountryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,
    bankingCountryCodeError: PropTypes.string,
    companyName: PropTypes.string,
    currency: PropTypes.string,
    currencyError: PropTypes.string,
    siteName: PropTypes.string,
    userType: PropTypes.string,
};

BrandDeterminationContainer.defaultProps = {
    publicUuid: '-1',
    bankingCountryCode: '',
    currencyList: [],
    bankingCountryList: [],
    enableContinueButton: false,
    serviceError: '',
    currency: '',
    currencyError: '',
    companyName: '',
    enableBackButton: true,
    siteName: '',
    userType: 'IPM'
};

export default BrandDeterminationContainer;
